/* src/app/contract/contract-view/contract-view.component.css */
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep .p-card {
  width: 100% !important;
  max-width: 100% !important;
}
:host ::ng-deep .p-fieldset {
  width: 100% !important;
  max-width: 100% !important;
  display: block !important;
}
:host ::ng-deep .p-fieldset .p-fieldset-content,
:host ::ng-deep .p-fieldset .p-toggleable-content {
  max-width: 100% !important;
  overflow: hidden;
}
:host ::ng-deep .p-datatable {
  width: 100% !important;
}
:host ::ng-deep .contract-details-table {
  width: 1300px !important;
}
:host ::ng-deep .overflow-x-auto {
  display: block !important;
  width: 100% !important;
  overflow-x: auto !important;
}
:host ::ng-deep .contract-table-scroll {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}
:host ::ng-deep .contract-table-inner {
  display: inline-block;
  min-width: 100%;
}
/*# sourceMappingURL=contract-view.component-7DTE5TBE.css.map */
